export class ParseError extends Error {
    kind;
    lineNumber;
    cause;
    constructor(kind, message, lineNumber, cause) {
        super(message);
        this.kind = kind;
        this.lineNumber = lineNumber;
        this.cause = cause;
        this.name = 'ParseError';
    }
}
//# sourceMappingURL=warnings.js.map